import React from 'react'
import Drawer from '@mui/material/Drawer'
import SelectedApplication from './SelectedApplication'
import SelectMatchingApplications from './SelectMatchingApplications'
import AlreadyFilledReview from './AlreadyFilledReview'

// Opens the right review drawer for a row from groupShiftApplications:
// stranded applications on a filled shift, a merged vacancy (pick N of the
// applicants), or a single application / swap request. `onReviewed` runs
// after any accept/reject so the caller can refetch.
const ApplicationReviewDrawer = ({ group, onClose, onReviewed }) => {
  const mode = !group
    ? null
    : group.alreadyFilled
      ? 'filled'
      : group.mergeable
        ? 'merged'
        : 'single'

  return (
    <>
      <Drawer anchor="right" open={mode === 'single'} onClose={onClose}>
        {mode === 'single' && (
          <SelectedApplication
            application={group.applications[0]}
            loadApplications={onReviewed}
            onClose={onClose}
          />
        )}
      </Drawer>

      <Drawer anchor="right" open={mode === 'merged'} onClose={onClose}>
        {mode === 'merged' && (
          <SelectMatchingApplications
            shiftID={group.shift._id}
            loadApplications={onReviewed}
            onClose={onClose}
          />
        )}
      </Drawer>

      <Drawer anchor="right" open={mode === 'filled'} onClose={onClose}>
        {mode === 'filled' && (
          <AlreadyFilledReview
            shift={group.shift}
            applications={group.applications}
            loadApplications={onReviewed}
            onClose={onClose}
          />
        )}
      </Drawer>
    </>
  )
}

export default ApplicationReviewDrawer
